<template>
    <b-modal ref="pwa_settings"
             size="xl"
             bodyClass="p-0"
             v-bind:no-close-on-backdrop=true
             :hide-header=true
             v-model="is_show_modal"
             :dialogClass=dialog_class_draw>

        <template v-slot:modal-header="{ close }">
            <b-button size="sm" variant="outline-danger" @click="close()">
                Close Modal
            </b-button>
        </template>

        <div id="panel_users_list" class="panel mb-0 border-bottom-0 shadow-none">
            <div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
                <h2 >
                    <span class="fw-300">Bolt Settings</span>
                </h2>
                <div class="panel-toolbar pr-3 pb-2 align-self-end">
                    <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
                        <i class="fal fa-times"></i>
                    </button>
                </div>
            </div>

            <div class="p-2 pl-4" >
                <div class="panel-tag">
                    {{__t("BOLT_DIRECTION")}}
                </div>
                <div class="directions">
                    <div class="custom-control custom-radio custom-radio-rounded mt-2" v-for="direction in bolt_settings.api_direction">
                        <input type="radio"
                               :value="direction"
                               v-model="active_direction"
                               class="custom-control-input" :id="'direction_radio' + direction" name="defaultExampleRadios">
                        <label class="custom-control-label" :for="'direction_radio' + direction">
                            {{__t('BOLT_DIRECTION_' + direction.toUpperCase())}}
                        </label>
                    </div>

                </div>
            </div>

        </div>

        <template v-slot:modal-footer="{close}">
            <div class="modal-footer">
                <button type="button" v-on:click="close_modal" class="btn btn-secondary waves-effect waves-themed">
                    {{__t("CLOSE")}}
                </button>

                <button type="button" v-on:click="save_settings" class="btn btn-primary waves-effect waves-themed">
                    {{__t("SAVE")}}
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script>
export default {
    name: "bolt_direction",
    data() {
        return {
            is_show_modal: false,
            is_load: false,
            bolt_settings: {
                api_direction : [],
                active_direction : null,
            },
        }
    },
    created() {
        EventBus.$on('show_bolt_settings',this.load_settings);
    },

    methods : {

        async load_settings() {
            this.is_load = true;
            this.is_show_modal = true;

            agr_api.get('/aggregators/bolt/direction').then(({data}) => {
                this.is_load = false;
                if (data.status == "operation_success") {
                    let resp = data.data;
                    if(resp.hasOwnProperty("directions")) {
                        this.bolt_settings.api_direction = resp.directions;
                    }

                    if(resp.hasOwnProperty("cur_direction")) {
                        if(resp.cur_direction != null ) {
                            this.bolt_settings.active_direction = resp.cur_direction.direction;
                        }
                    }
                }
            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: this.__t("BOLT_GET_PARAMS")
                })
            });

        },

        close_modal () {
            this.close();
        },
        close() {
            this.is_show_modal = false;
        },

        save_settings() {
            this.is_load = true;
            agr_api.put('/aggregators/bolt/direction',{
                'direction' : this.bolt_settings.active_direction
            }).then(({data}) => {
                this.is_load = false;
                if (data.status == "operation_success") {
                    this.close_modal();
                }
            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: this.__t("BOLT_GET_PARAMS")
                })
            });
        }
    },
    computed: {
        active_direction : {
            get() {
                if(this.bolt_settings.active_direction != null) {
                    return this.bolt_settings.active_direction;
                }

                return null;
            },
            set(val) {
                if(this.bolt_settings.active_direction === val) {
                    this.bolt_settings.active_direction = null;
                }
                else {
                    this.bolt_settings.active_direction = val;
                }
            }
        },

        dialog_class_draw () {
            if(this.modal_position === "left") {
                return "modal-dialog-left modal-lg";
            }

            return "modal-dialog-right modal-lg";
        },
    }

}
</script>

<style scoped>

</style>
